import LocalStorageService from "services/localStorage";

export default () => LocalStorageService.get("lang") || "he";
